jQuery(document).ready(function ($) {
    $('.block--lux-news-slider').each(function () {
        let owl = $(this).find(' .owl-carousel');
        if (!owl) return;
        owl.owlCarousel({
            items: 1,
            //animateIn: 'fadeIn',
            margin: 10,
            loop: true,
            nav: false,
            dots: false,
            autoplay: true,
            autoplayTimeout: 4000,
            autoplayHoverPause: true,
        });
    });


    /*
    * Hide the sticky after scrolling
    */
    let $header = $('.vf-news-slider');

    function toggleHeaderFixed() {
        if ($(window).scrollTop() > 100) {
            $header.addClass('hide');
        } else {
            $header.removeClass('hide');
        }
    }

    $(window).on('scroll', toggleHeaderFixed);
});
